module.exports = __webpack_public_path__ + "media/svg/sk-5ff847c7.svg";